export default {
  en: "English",
  sv: "Swedish",
  pl: "Polish",
  no: "Norsk",
  nl: "Nederlands"
};
